// @ts-nocheck
import { useEffect, useState } from "react";

/**
 * Tracks which `[data-section-id]` block is currently being read.
 *
 * Deliberately plain scroll maths rather than IntersectionObserver: the answer is
 * needed on every scroll anyway, it is only a handful of elements to measure, and
 * it behaves identically in every browser.
 *
 * @param {number} offset  distance from the top of the viewport that counts as
 *                         "current" - roughly the header plus the tab bar.
 * @param {boolean} enabled
 */
export const useActiveSection = (offset = 140, enabled = true) => {
    const [activeId, setActiveId] = useState(null);

    useEffect(() => {
        if (!enabled) return undefined;

        const compute = () => {
            const sections = document.querySelectorAll("[data-section-id]");
            if (!sections.length) return;

            let current = sections[0];
            sections.forEach((el) => {
                if (el.getBoundingClientRect().top <= offset) current = el;
            });
            const id = current.getAttribute("data-section-id");
            setActiveId((prev) => (prev === id ? prev : id));
        };

        compute();
        window.addEventListener("scroll", compute, { passive: true });
        window.addEventListener("resize", compute);
        return () => {
            window.removeEventListener("scroll", compute);
            window.removeEventListener("resize", compute);
        };
    }, [offset, enabled]);

    return activeId;
};

export default useActiveSection;
